import { createContext, useContext, useEffect, useState } from 'react';
import { getPlayerInfo } from './api/getPlayerInfo';
import { getGroupInfo } from './api/getGroupInfo';
import { getLeagueInfo } from './api/getLeagueInfo';

const DEVTOOLS_STORAGE_KEY = "hachaluts.devtools.settings";
const DEFAULT_DEVTOOLS_SETTINGS = {
  devMode: false,
  preventRedirect: false,
  quickSignUp: false,
};


export const LeagueContext = createContext();
export const LeagueUpdateContext = createContext();
export const GroupContext = createContext();
export const GroupUpdateContext = createContext();
export const PlayerContext = createContext();
export const PlayerUpdateContext = createContext();
export const DevToolsContext = createContext(DEFAULT_DEVTOOLS_SETTINGS);
export const DevToolsUpdateContext = createContext(() => {});

function normalizeDevToolsSettings(settings) {
  const source = settings && typeof settings === "object" ? settings : {};

  return {
    devMode: Boolean(source.devMode),
    preventRedirect: Boolean(source.preventRedirect),
    quickSignUp: Boolean(source.quickSignUp),
  };
}

function readDevToolsSettings() {
  if (typeof window === "undefined") {
    return normalizeDevToolsSettings(DEFAULT_DEVTOOLS_SETTINGS);
  }

  try {
    const saved = window.localStorage.getItem(DEVTOOLS_STORAGE_KEY);
    if (!saved) {
      return DEFAULT_DEVTOOLS_SETTINGS;
    }

    const parsed = JSON.parse(saved);
    return normalizeDevToolsSettings({
      ...DEFAULT_DEVTOOLS_SETTINGS,
      ...parsed,
    });
  } catch (error) {
    return normalizeDevToolsSettings(DEFAULT_DEVTOOLS_SETTINGS);
  }
}

export const DevToolsProvider = ({ children }) => {
  const [devToolsSettings, setDevToolsSettings] = useState(() =>
    readDevToolsSettings()
  );

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    try {
      window.localStorage.setItem(
        DEVTOOLS_STORAGE_KEY,
        JSON.stringify(devToolsSettings)
      );
    } catch (error) {
    }
  }, [devToolsSettings]);

  function updateDevToolsSettings(updater) {
    setDevToolsSettings(prevSettings => {
      const nextSettings =
        typeof updater === "function"
          ? updater(prevSettings)
          : { ...prevSettings, ...updater };

      const normalizedSettings = normalizeDevToolsSettings({
        ...DEFAULT_DEVTOOLS_SETTINGS,
        ...nextSettings,
      });

      return normalizedSettings;
    });
  }

  return (
    <DevToolsContext.Provider value={devToolsSettings}>
      <DevToolsUpdateContext.Provider value={updateDevToolsSettings}>
        {children}
      </DevToolsUpdateContext.Provider>
    </DevToolsContext.Provider>
  );
};


export const AppProvider = ({ children }) => {

  const [league, setLeague] = useState({});
  const [group, setGroup] = useState({});
  const [player, setPlayer] = useState({});


  function setObjPlayer(objPlayer) {
    setPlayer(objPlayer);
  }

  async function getObjPlayer(league_pk, team_pk, userId) {



    let res;

    if (Object.keys(player).length === 0) {
      res = await getPlayerInfo(league_pk, team_pk, userId);
      setPlayer(res);
    } else {
      res = player;
    }
    return res;
  }


  function setObjGroup(objGroup) {
    setGroup(objGroup);
  }

  async function getObjGroup(league_pk, team_pk) {



    let res;

    if (Object.keys(group).length === 0) {
      res = await getGroupInfo(league_pk, team_pk);
      setGroup(res);
    } else {
      res = group;
    }
    return res;
  }


  function setObjLeague(objLeague) {
    setLeague(objLeague);
  }

  async function getObjLeague(league_pk) {



    let res;

    if (Object.keys(league).length === 0) {
      res = await getLeagueInfo(league_pk);
      setLeague(res);
    } else {
      res = league;
    }
    return res;
  }

  return (
    <LeagueContext.Provider value={getObjLeague}>
      <LeagueUpdateContext.Provider value={setObjLeague}>
        <GroupContext.Provider value={getObjGroup}>
          <GroupUpdateContext.Provider value={setObjGroup}>
            <PlayerContext.Provider value={getObjPlayer}>
              <PlayerUpdateContext.Provider value={setObjPlayer}>
                {children}
              </PlayerUpdateContext.Provider>
            </PlayerContext.Provider>
          </GroupUpdateContext.Provider>
        </GroupContext.Provider>
      </LeagueUpdateContext.Provider>
    </LeagueContext.Provider>
  );
};


export const useLeague = () => useContext(LeagueContext);
export const useUpdateLeague = () => useContext(LeagueUpdateContext);
export const useGroup = () => useContext(GroupContext);
export const useUpdateGroup = () => useContext(GroupUpdateContext);
export const usePlayer = () => useContext(PlayerContext);
export const useUpdatePlayer = () => useContext(PlayerUpdateContext);
export const useDevTools = () => useContext(DevToolsContext);
export const useUpdateDevTools = () => useContext(DevToolsUpdateContext);
